import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'

export interface ILocationBadgeProps {
  location?: string
}

export const Location = ({ location }: ILocationBadgeProps) => (
  location &&
  (<Badge use={badges.TEXT}>
    <span data-automation-id="location-badge">{location}</span>
  </Badge>) || null
)
